<template>
  <base-info @btn-update="handleUpdate" />
</template>
<script>
import baseInfo from "../baseInfo";
export default {
  components: { baseInfo },
  mounted() {
    this.handleUpdate();
  },
  methods: {
    handleUpdate() {
      //处理个性化样式
      this.$nextTick(x => {
        let dom = document.querySelector("input[class~='btn-info-submit']");
        let dom2 = document.querySelector("input[class~='btn-info-active']");
        if (dom) {
          dom.classList.add("btn-init-br");
        }
        if (dom2) {
          dom2.classList.add("btn-active-br");
          let up = new URLSearchParams(location.search);
          if (up.get("business_line") === "oasis") {
            dom2.classList.add("btn-vamos-active-br");
          }
        }
      });
    }
  }
};
</script>

<style lang="scss">
.btn-init-br {
  width: 6.84rem;
  height: 1.06rem;
  font-size: 0.4rem;
  color: #fff;
  text-align: center;
  background-color: #afb0b3;
}
.btn-active-br {
  color: #323233;
  background-color: #ffe600;
}
.btn-vamos-active-br {
  font-weight: bold;
  background: linear-gradient(135deg, #fff362 0%, #fd9728 100%);
}
</style>


